import { createContext, useState } from "react";

export const MenuContext = createContext();
export const MenuProvider = ({children})=>{
    const [menuOpen, setIsMenuOpen] = useState(false);
    return (
        <MenuContext.Provider value ={{menuOpen, setIsMenuOpen}}>
            {children}
        </MenuContext.Provider>
    )
}